import { BaseTicketController } from '../../../../common/base/ticketController';
import { TicketType } from '../../ticket.constants';
import { receivingListStateName } from '../../../tickets/ticketOverview/ticketOverview.state';
import { waitForTransferringStateName } from '../waitForTransferring/waitForTransferring.state';

export class FinancesController extends BaseTicketController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    super.$onInit();

    const ticketType = TicketType.Receiving;
    this.ticketService.fetchTransactions(ticketType, this.ticket.id)
      .busy(this, 'isFetchTranscationsBusy')
      .then(partners => this.setFinances(partners));
  }

  canUpload() {
    return this.ticketService.canUploadTransferringData();
  }

  canRefreshTicket() {
    // Data capturing provider can only handle this kind of ticket state
    // and therefor can not handle a refreshed ticket with another state.
    return !this.userService.isDataCapturingProvider();
  }

  setFinances(finances) {
    if (finances) {
      this.finances = {
        directDebits: this.extractDirectDebits(finances),
        receivedPayments: this.extractReceivedPayments(finances),
        standingOrders: this.extractStandingOrders(finances)
      };
    }
  }

  extractDirectDebits(finances) {
    return finances.debits || finances.directDebits;
  }

  extractReceivedPayments(finances) {
    return finances.deposits || finances.receivedPayments;
  }

  extractStandingOrders(finances) {
    // Concat standingOrders with scheduledTransactions
    return (finances.transfers || finances.standingOrders || []).concat(finances.scheduledTransactions || []);
  }

  submit(finances) {
    const { ticketService } = this;
    const refresh = this.canRefreshTicket();

    // if we added "edit" to url to edit finances state, we have to remove it from params to handle the ticket flow.
    if (this.$stateParams.edit) {
      delete this.$stateParams.edit;
    }

    ticketService
      .putFinances(this.ticket.id, { finances }, refresh)
      .busy(this, 'isSubmitBusy')
      .then(ticketResult => {
        // Attention for the implicit ticketChanged-Event:
        // For the "data capturing provider" we need to prevent
        // this implicit call and forwarding to next state
        // since this role is only allowed to view tickets for this state.
        if (!refresh && ticketService.hasStatus(ticketResult, ticketService.TicketStates.VERIFIED_FINANCES)) {
          this.go(receivingListStateName);
        }
      });
  }

  back() {
    this.go(waitForTransferringStateName, { upload: this.canUpload() });
  }
}
